/**********************************************************
Hawaiian Macadamia Nut Services
Alexander Self
7/14/20
Irrigation Reducer: Handles all state changes with irrigation
**********************************************************/
import moment from 'moment';
import { FETCH_IRRIGATION, FETCH_IRRIGATION_EMPLOYEES, HANDLE_ENGINE_HOURS,
  HANDLE_METER_GALLONS, HANDLE_VALVE_HOURS, PREPARE_IRRIGATION_DATA,
  CREATE_IRRIGATION, SELECT_IRRIGATION_LOG_TO_EDIT, DELETE_IRRIGATION,
  HANDLE_EDIT_ENGINE_HOURS, HANDLE_EDIT_METER_GALLONS, HANDLE_EDIT_VALVE_HOURS,
  PREPARE_EDIT_IRRIGATION_DATA, EDIT_IRRIGATION, FETCH_IRRIGATION_REPORT,
  RESET_DASHBOARD
} from './types';
import { handleLog } from './irrigation_utils';

const initState = {
  utils: {
    engines: [],
    meters: [],
    valves: [],
    employees: []
  },
  view: {
    all: [],
    displaying: [],
    dashboard: false,
    dashboardData: {
      startDate: null,
      endDate: null
    }
  },
  create: {
    app: {
      data: {},
      engineLog: [],
      meterLog: [],
      valveLog: []
    },
    prevMeters: []
  },
  edit: {
    app: {
      data: {},
      engineLog: [],
      meterLog: [],
      valveLog: []
    },
    deleted: {
      engineLog: [],
      meterLog: [],
      valveLog: []
    }
  }
};

export default function IrrigationReducer(state=initState, action) {
  switch (action.type) {
    case FETCH_IRRIGATION:
      return { ...state,
        utils: { ...state.utils,
          engines: action.payload.engines,
          meters: action.payload.meters,
          valves: action.payload.valves
        },
        view: { ...state.view,
          all: action.payload.irrigationLogs,
          displaying: action.payload.irrigationLogs.sort(sortByDateField)
        },
        create: { ...state.create,
          prevMeters: action.payload.prevMeters
        }
      };
    case FETCH_IRRIGATION_EMPLOYEES:
      return { ...state,
        utils: { ...state.utils,
          employees: action.payload
        }
      };
    case HANDLE_ENGINE_HOURS:
      return { ...state,
        create: { ...state.create,
          app: { ...state.create.app,
            engineLog: handleLog({ payload: action.payload, log: state.create.app.engineLog, prop: 'hours', id: 'engineId' })
          }
        }
      }
    case HANDLE_EDIT_ENGINE_HOURS:
      let deleteEngineLog = false;
      let engLog = {};
      if (Number(action.payload.hours) === 0 && state.edit.app.engineLog.find((v) => Number(v.engineId) === Number(action.payload.engineId))) {
        deleteEngineLog = true;
        engLog = state.edit.app.engineLog.find((v) => Number(v.engineId) === Number(action.payload.engineId));
      }
      return { ...state,
        edit: { ...state.edit,
          app: { ...state.edit.app,
            engineLog: handleLog({ payload: action.payload, log: state.edit.app.engineLog, prop: 'hours', id: 'engineId' })
          },
          deleted: { ...state.edit.deleted,
            engineLog: deleteEngineLog ? state.edit.deleted.engineLog.concat(engLog) : state.edit.deleted.engineLog
          }
        }
      }
    case HANDLE_METER_GALLONS:
      return { ...state,
        create: { ...state.create,
          app: { ...state.create.app,
            meterLog: handleLog({ payload: action.payload, log: state.create.app.meterLog, prop: 'totalGal', id: 'meterId' })
          }
        }
      }
    case HANDLE_EDIT_METER_GALLONS:
      let deleteMeterLog = false;
      let metLog = {};
      if (Number(action.payload.totalGal) === 0 && state.edit.app.meterLog.find((v) => Number(v.meterId) === Number(action.payload.meterId))) {
        deleteMeterLog = true;
        metLog = state.edit.app.meterLog.find((v) => Number(v.meterId) === Number(action.payload.meterId));
      }
      return { ...state,
        edit: { ...state.edit,
          app: { ...state.edit.app,
            meterLog: handleLog({ payload: action.payload, log: state.edit.app.meterLog, prop: 'totalGal', id: 'meterId' })
          },
          deleted: { ...state.edit.deleted,
            meterLog: deleteMeterLog ? state.edit.deleted.meterLog.concat(metLog) : state.edit.deleted.meterLog
          }
        }
      }
    case HANDLE_VALVE_HOURS:
      return { ...state,
        create: { ...state.create,
          app: { ...state.create.app,
            valveLog: handleLog({ payload: action.payload, log: state.create.app.valveLog, prop: 'hours', id: 'valveId' })
          }
        }
      };
    case HANDLE_EDIT_VALVE_HOURS:
      let deleteValveLog = false;
      let _valveLog = {};
      if (Number(action.payload.hours) === 0 && state.edit.app.valveLog.find((v) =>  Number(v.valveId) ===  Number(action.payload.valveId))) {
        deleteValveLog = true;
        _valveLog = state.edit.app.valveLog.find((v) => Number(v.valveId) === Number(action.payload.valveId));
      }
      return { ...state,
        edit: { ...state.edit,
          app: { ...state.edit.app,
            valveLog: handleLog({ payload: action.payload, log: state.edit.app.valveLog, prop: 'hours', id: 'valveId' })
          },
          deleted: { ...state.edit.deleted,
            valveLog: deleteValveLog ? state.edit.deleted.valveLog.concat(_valveLog) : state.edit.deleted.valveLog
          }
        }
      };
    case PREPARE_IRRIGATION_DATA:
      return { ...state,
        create: { ...state.create,
          app: action.payload
        }
      };
    case CREATE_IRRIGATION:
      return { ...state,
        view: { ...state.view,
          all: state.view.all.concat(action.payload.irrigationLog),
          displaying: state.view.displaying.concat(action.payload.irrigationLog).sort(sortByDateField)
        },
        create: {
          app: initState.create.app,
          prevMeters: action.payload.prevMeters
        }
      };
    case SELECT_IRRIGATION_LOG_TO_EDIT:
      return { ...state,
        edit: { ...state.edit,
          app: action.payload,
          deleted: initState.edit.deleted
        }
      };
    case DELETE_IRRIGATION:
      return { ...state,
        view: { ...state.view,
          all: state.view.all.filter((i) => i.irrigationId !== action.payload),
          displaying: state.view.displaying.filter((i) => i.irrigationId !== action.payload)
        },
        create: { ...state.create,
          prevMeters: action.prevMeters
        }
      }
    case PREPARE_EDIT_IRRIGATION_DATA:
      return { ...state,
        edit: { ...state.edit,
          app: action.payload
        }
      };
    case EDIT_IRRIGATION:
      return { ...state,
        view: { ...state.view,
          all: state.view.all.filter((i) => i.id !== action.payload.irrigationLog.id).concat(action.payload.irrigationLog),
          displaying: state.view.displaying.filter((i) => i.id !== action.payload.irrigationLog.id).concat(action.payload.irrigationLog).sort(sortByDateField)
        },
        create: { ...state.create,
          prevMeters: action.payload.prevMeters
        },
        edit: initState.edit
      }
    case FETCH_IRRIGATION_REPORT:
      return { ...state,
        view: { ...state.view,
          dashboard: true,
          dashboardData: {
            ...action.payload,
            startDate: action.startDate,
            endDate: action.endDate
          }
        }
      };
    case RESET_DASHBOARD:
      return { ...state,
        view: { ...state.view,
          dashboard: initState.view.dashboard,
          dashboardData: initState.view.dashboardData
        }
      }
    default:
      return state;
  }
}

function sortByDateField(a,b) {
  if ((moment(a.date).format('YYYY-MM-DD')) < (moment(b.date).format('YYYY-MM-DD'))) return 1;
  else if ((moment(a.date).format('YYYY-MM-DD')) > (moment(b.date).format('YYYY-MM-DD'))) return -1;
  else if ((moment(a.date).format('YYYY-MM-DD')) === (moment(b.date).format('YYYY-MM-DD'))) {
    if (a.id < b.id) return -1;
    else if (a.id > b.id) return 1;
    return 0;
  }
  return 0;
}


/* END */



// WEBPACK FOOTER //
// ./src/irrigation/reducer.js